import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BASE_URL } from '../utils/constants';
import { ListResource } from '../utils/lazy-data-source';
import {
  ApiLink,
  ApiListWrapper,
  ApiRequestParams,
  DeepPartial,
} from '../utils/types';
import { AuditRevision } from './audit-revisions.resource';

export const ADMIN_DEFAULT_ID = 1;
export const OPERATOR_DEFAULT_ID = 13;
export const BA_ADMIN_DEFAULT_ID = 16;

export enum RoleCode {
  SUPER_ADMIN = 'rtls_admin',
  OPERATOR = 'rtls_user',
  ADMINISTRATOR = 'rtls_ba_admin',
}

export interface Role {
  _links: {
    self: ApiLink<RoleCode>;
    users: ApiLink<string>[];
  };
  id: number;
  name: string;
  code: RoleCode;
  descr?: string;
  deleted: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class RolesResource implements ListResource<Role> {
  constructor(private httpClient: HttpClient) {
  }

  getList(params?: ApiRequestParams): Observable<ApiListWrapper<Role>> {
    return this.httpClient.get<ApiListWrapper<Role>>(`${BASE_URL}/roles`, { params });
  }

  getItem(id: number): Observable<Role> {
    return this.httpClient.get<Role>(`${BASE_URL}/roles/${id}`);
  }

  create(role: DeepPartial<Role>): Observable<void> {
    return this.httpClient.post<void>(`${BASE_URL}/roles`, role);
  }

  update(id: number, role: DeepPartial<Role>): Observable<void> {
    return this.httpClient.patch<void>(`${BASE_URL}/roles/${id}`, role);
  }

  getRevisions(id: number, offset?: number, limit?: number): Observable<ApiListWrapper<AuditRevision>> {
    const params: ApiRequestParams = { offset, limit };
    return this.httpClient.get<ApiListWrapper<AuditRevision>>(`${BASE_URL}/roles/${id}/revisions`, { params });
  }

  getRevision(id: string, rev: number): Observable<ApiListWrapper<AuditRevision>> {
    return this.httpClient.get<ApiListWrapper<AuditRevision>>(`${BASE_URL}/roles/${id}/revisions/${rev}`, { });
  }
}
